export default __webpack_public_path__ + "static/media/footer_sponsors@2x.9f85f555.png";